import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Handles the Emergent Google OAuth callback.
 * URL arrives as /welcome#session_id=... — AppRouter detects the fragment
 * and renders this component BEFORE any protected routes or /auth/me checks.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/signup', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const user = await processGoogleSession(sessionId);
        // Clean the hash so refreshes don't re-trigger
        window.history.replaceState(null, '', window.location.pathname);
        navigate(user.onboarding_completed ? '/home' : '/welcome', { replace: true });
      } catch (e) {
        navigate('/signup?error=google', { replace: true });
      }
    })();
  }, [navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-amber-600 mx-auto mb-3" />
        <p className="text-sm text-slate-600">Signing you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
